import { ChatInterface } from "../components/ChatInterface";
// import { mockChats, mockProducts } from "../lib/mockData";
import { ProductPanel } from "../components/ProductPanel";
import React, { useState } from 'react';
// import { Columns2 } from "lucide-react";
import type { Product } from '../lib/mockData';
import clsx from 'clsx';
import { useChat } from "../context/ChatContext";
import { X } from 'lucide-react';

function Chat() {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const { setCurrentProduct } = useChat();

  // Handler to open the product panel with the full product object
  const handleProductSelect = (product: Product) => {
    setSelectedProduct(product);
    setCurrentProduct(product.id);
  };

  // Handler to close the product panel
  const handleClosePanel = () => {
    setSelectedProduct(null);
    setCurrentProduct(null);
  };

  return (
    <div className="relative w-full h-screen flex bg-[var(--color-background)]">
      {/* Chat area */}
      <div
        className={clsx(
          "relative h-full transition-all duration-300 ease-in-out w-full flex items-center justify-center"
        )}
      >
        <ChatInterface onProductSelect={handleProductSelect} />
      </div>

      {/* Scrim overlay (desktop only) */}
      {selectedProduct && (
        <div
          className="hidden md:block fixed inset-0 z-40 backdrop-blur-sm bg-black/5 transition-opacity duration-300"
          onClick={handleClosePanel}
        />
      )}

      {/* Sliding product panel */}
      <div
        role="dialog"
        aria-modal="true"
        className={clsx(
          "fixed top-0 right-0 h-full z-50 transform transition-transform transition-opacity duration-300 ease-in-out bg-white shadow-lg",
          "w-full md:w-1/2",
          selectedProduct ? "translate-x-0 opacity-100 pointer-events-auto" : "translate-x-full opacity-0 pointer-events-none"
        )}
      >
        {/* Stop propagation so clicks inside panel don't close it */}
        <div className="h-full w-full relative" onClick={(e) => e.stopPropagation()}>
          <button
            className="absolute top-4 left-4 z-10 w-8 h-8 flex items-center justify-center rounded-full shadow-sm"
            style={{
              background: 'var(--color-background)',
              transition: 'color 0.2s',
            }}
            onClick={handleClosePanel}
            aria-label="Stäng panel"
          >
            <X
              className="w-[16px] h-[16px]"
              style={{
                color: 'var(--color-text-secondary)',
                transition: 'color 0.2s',
              }}
            />
            <style>{`
              button.absolute.top-4.left-4:hover svg {
                color: var(--color-primary) !important;
              }
            `}</style>
          </button>
          {selectedProduct && <ProductPanel {...selectedProduct} />}
        </div>
      </div>
    </div>
  );
}

export default Chat;
